import React, { useState, useEffect } from 'react';
import { FaCogs, FaPlus, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import axios from 'axios';
import { rootUrl } from '../../helpers';
import FormGenerator from '../../components/formGenerator';
import ModalDefault from '../../components/ModalDefault';
import { useAuth } from '../../context/auth-context';

export default function Settings() {
  const auth = useAuth();
  const [modal, setModal] = useState({ title: '', open: false, body: '', size: 'sm' });
  const [activeTab, setActiveTab] = useState(0); // To manage tabs

  let type = '';

  const [budget, setBudget] = useState([]);
  const [banks, setBanks] = useState([]);
  const [coa, setCoa] = useState([]);
  const [dept, setDept] = useState([]);
  const [program, setProgram] = useState([]);
  const [subProgram, setSubProgram] = useState([]);
  const [units, setUnits] = useState([]);
  const [councils, setCouncil] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [center, setCenter] = useState([]);
  const [output, setOutput] = useState([]); 


  const handleClose = () => {
    setModal({ ...modal, open: false });
  };

  const fetchData = async () => {
    try {
      const { data } = await axios.get(rootUrl(`/getProjects/${auth.user.id}`));
      setBudget(data.data.budget);
      setCoa(data.data.coa);
      setDept(data.data.dept);
      setProgram(data.data.program);
      setSubProgram(data.data.subProgram);
      setOutput(data.data.subProgram);
      setUnits(data.data.units);
      setCouncil(data.data.councils);
      setBanks(data.data.banks);
      setExpenses(data.data.expenses);
      setCenter(data.data.center);
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (auth.user != null) {
      fetchData();
    }
  }, []);

  const submitSetting = async (data) => {
    data['type'] = type;
    data['c_id'] = auth.user.cid;
    try {
      const response = await axios.post(rootUrl('/settings'), data);
      if (response.data.status === 200) {
        toast.success('Submitted successfully');
        fetchData();
        setModal({ ...modal, open: false });
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const addSett = (name) => {
    type = name;
    let fields = [{ type: 'text', name: 'name', label: 'Name' }];

    switch (name) {
      case 'council':
        fields = [{ type: 'text', name: 'code', label: 'Code' }, { type: 'text', name: 'name', label: 'Name' }];
        break;
      case 'bank':
          fields = [{ type: 'text', name: 'code', label: 'Code' }, { type: 'text', name: 'account_no', label: 'Account #' }, { type: 'text', name: 'name', label: 'Name' }];
          break;
    
      case 'center':
            fields = [{ type: 'text', name: 'collection_name', label: 'Name' }];
            break;
              
      case 'department':
        fields = [{ type: 'text', name: 'id', label: 'Id' }, { type: 'text', name: 'name', label: 'Name' }];
        break;
      case 'program':
        fields = [{ type: 'text', name: 'programCode', label: 'Code' }, { type: 'text', name: 'programName', label: 'Name' }];
        break;
      case 'sub':
        fields = [
          { type: 'text', name: 'subProgramCode', label: 'Code' },
          { type: 'text', name: 'name', label: 'Name' },
          {
            type: 'select',
            name: 'programCode',
            label: 'Program',
            required: true,
            options: program.map((res) => ({ value: res.programCode, label: res.name })),
          },
        ];
        break;
        
      case 'coa':
        fields = [ { type: 'text', name: 'name', label: 'Name' },{ type: 'text', name: 'account', label: 'Account Number' }, 
        {type:'select', name:'ctype', label:'type', options:[{value:'rev', label:'Income'}, {value:'exp', label:'Expense'}, {value:'ass', label:'Asset'}, {value:'lia', label:'Liability'}]}];
        break;
      default:
        break;
    }

    setModal({
      title: 'Add ' + name,
      open: true,
      size: 'sm',
      body: <FormGenerator fields={fields} onSubmit={submitSetting} />,
    });
  };

  const tabData = [
    // { name: 'Councils', list: councils, addFunc: 'council' },
    { name: 'Departments', list: dept, addFunc: 'department' },
    { name: 'Programs', list: program, addFunc: 'program' },
    { name: 'SubPrograms', list: subProgram, addFunc: 'sub' },
    { name: 'Banks', list: banks, addFunc: 'bank' },
    { name: 'Collection Center', list: center, addFunc: 'center' },
    { name: 'COA', list: coa, addFunc: 'coa' },
  ];

  return (
    <div className="bg-white p-4 rounded-lg shadow-lg">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-semibold text-xl flex items-center">
          <FaCogs className="mr-2" /> Setup
        </h2>
      </div>
      <hr className="my-3" />

      {/* Custom Tab Navigation */}
      <div className="flex space-x-4 border-b-2 border-gray-200">
        {tabData.map((tab, index) => (
          <button
            key={index}
            className={`py-2 px-4 focus:outline-none ${
              activeTab === index
                ? 'border-b-2 border-blue-950 text-blue-950 font-semibold'
                : 'text-gray-500 hover:text-blue-950'
            }`}
            onClick={() => setActiveTab(index)}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="mt-4 p-4 border border-gray-200">
        {tabData.map((tab, index) => (
          <div key={index} className={`${activeTab === index ? 'block' : 'hidden'}`}>
            <div className="shadow-md border rounded-lg p-4">
              <div className="flex justify-between items-center">
                <h3 className="font-bold text-lg">{tab.name}</h3>
                <button
                  onClick={() => addSett(tab.addFunc)}
                  className="flex items-center bg-blue-950 text-white rounded px-2 py-1"
                >
                  <FaPlus className="mr-1" /> Add
                </button>
              </div>
              <div className="overflow-y-auto max-h-60 mt-2">
                <ul>
                  {tab.list.length > 0 ? (
                    tab.list.map((entry, idx) => (
                      <li key={idx} className="flex justify-between items-center m-2">
                        <div className="flex items-center gap-4">
                          <span className="font-semibold">{idx + 1}</span> {entry.name}
                        </div>
                        <FaTrash className="text-red-500 cursor-pointer" />
                      </li>
                    ))
                  ) : (
                    <li>No {tab.name.toLowerCase()} available.</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      <ModalDefault title={modal.title} size={modal.size} open={modal.open} onClose={handleClose} body={modal.body} />
    </div>
  );
}
